<header class="pt-topbar header" #header>
  <div class="container pt-md-4 header__inner">
    <div class="row header__row">
      <div class="col-md-24 header__above-container">
        <ng-content select="[above]"></ng-content>
      </div>

      <div class="col-md-12 header__content-container pb-3 pt-md-5" [class.pe-md-5]="hasMedia()">
        <div class="py-2 px-3 px-md-0 header__content-container__inner">
          @if (subTitle() || mobileSubTitleSuffix()) {
            <strong class="fw-normal d-inline-block w-100 mb-2" [class.d-md-none]="!subTitle()">
              @if (subTitle()) {
                <span>{{ subTitle() }}</span>

                @if (mobileSubTitleSuffix()) {
                  <span class="d-inline-block d-md-none">,&nbsp;</span>
                }
              }
              @if (mobileSubTitleSuffix(); as suffix) {
                <span class="d-md-none">{{ suffix }}</span>
              }
            </strong>
          }

          @if (title(); as title) {
            <h1 class="h2 text-max-width-sm">
              @if (titleSmall(); as titleSmall) {
                <small class="fs-body-md fw-normal d-inline-block w-100 mb-2 text-highlight">{{ titleSmall }}</small>
              }
              <span class="d-inline-block w-100">{{ title }}</span>
            </h1>
          }
          @if (cleanIntro(); as intro) {
            <div
              class="markdown-content markdown-content--stripped"
              fstrDynamicContent
              [innerHTML]="intro | resizeHtmlImages | stripEmbed: undefined | safe"
            ></div>
          }

          @if (!hideScrollButton()) {
            <button class="button button-link button--dark button--sm mt-3 d-md-none" (click)="scrollToContent.emit()" type="button">
              <span>{{ 'event-header-lees-meer' | fromDictionary }}</span>
              <fstr-icon anchor="icon-arrow-down"></fstr-icon>
            </button>
          }
        </div>

        <ng-content select="[content]"></ng-content>
      </div>

      @if (hasMedia()) {
        <div class="col-md-12 header__figure-container">
          <figure class="pull-e header-media">
            @if (eventLabel()) {
              <li class="position-absolute z-1 header-media__label bg-secondary">
                <span class="text-light">{{ eventLabel() }}</span>
              </li>
            }
            @if (youtubeUrl(); as youtubeUrl) {
              <app-youtube class="header-media__video" [url]="youtubeUrl"></app-youtube>
            } @else {
              @if (image() && image()?.url) {
                <!--<fstr-image class="header-media__image" [priority]="true" [image]="image" [format]="'webp'" [fill]="true" ></fstr-image>-->
                <img
                  class="header-media__image position-relative"
                  [ngSrc]="image()?.url!"
                  [alt]="image()?.alt"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  priority="true"
                  [fill]="true"
                  [attr.data-object-position]="image()?.anchor"
                  (load)="loaded.emit(true)"
                />
              }
            }
          </figure>
        </div>
      }
    </div>

    <div class="position-relative z-2" #contentbelow>
      <ng-content select="[below]"></ng-content>
    </div>
  </div>

  <ng-content select="[below-container]"></ng-content>
</header>
